import React, { Component } from 'react';
import Parallax from 'parallax-js';

import './ParallaxScene.scss';

class ParallaxScene extends Component {

	constructor() {
        super();

        this.scene;
        this.parallaxInstance;
	}

    initParallax() {
        this.scene = document.getElementById('scene');
        this.parallaxInstance = new Parallax(this.scene);
    }

    componentDidMount() {
        this.initParallax();
    }

    componentWillUnount() {
    }

	render() {
        return (
        	<div className="parallax_scene" id="scene">
                { this.props.children }
            </div>
    	);
	}
}

export { ParallaxScene };